const About = () => {
  
  return (
    <section id="about" className="min-h-[100svh] sm:min-h-0 py-10 sm:py-20 bg-white dark:bg-black flex flex-col justify-center transition-colors duration-300">
      <div className="max-w-5xl mx-auto px-4 w-full">
        {/* Section Title */}
        <div className="text-center mb-12 sm:mb-16" data-aos="fade-up">
          <h2 className="text-2xl sm:text-3xl font-bold text-black dark:text-white mb-3 sm:mb-4 transition-colors duration-300">
            About Me
          </h2>
          <div className="w-12 sm:w-16 h-1 bg-black dark:bg-white mx-auto transition-colors duration-300"></div>
        </div>

        {/* Bio */}
        <div className="max-w-3xl mx-auto text-left sm:text-center space-y-6 mb-16 sm:mb-20" data-aos="fade-up" data-aos-delay="100">
          <p className="text-base sm:text-lg text-slate-700 dark:text-gray-300 leading-relaxed transition-colors duration-300">
            I am a <span className="font-semibold text-black dark:text-white transition-colors duration-300">Front-End Engineer and UI/UX Designer</span> who believes that great development goes beyond writing clean code, it is about crafting intuitive, seamless experiences. I have a keen eye for good UI and am highly particular about user experience. My approach is simple: I always put myself in the user's shoes. By genuinely understanding their needs and frustrations, I can build web applications that feel natural, accessible, and enjoyable to navigate.
          </p>
          <p className="text-base sm:text-lg text-slate-700 dark:text-gray-300 leading-relaxed transition-colors duration-300">
            The tech landscape moves fast, and I make it a priority to continuously evolve. I stay up to date with the latest technologies, and new methodologies to maximize my overall efficiency. I am also an avid <span className="font-semibold text-black dark:text-white transition-colors duration-300">AI enthusiast</span>, constantly exploring how emerging tools can help me work smarter, keep pace with modern workflows, and deliver better results.
          </p>
          <p className="text-base sm:text-lg text-slate-700 dark:text-gray-300 leading-relaxed transition-colors duration-300">
            At my core, I am a <span className="font-semibold text-black dark:text-white transition-colors duration-300">jack of all trades</span> with a <span className="font-semibold text-black dark:text-white transition-colors duration-300">
              relentless problem-solving mindset</span>. I firmly believe that no problem is unsolvable and nothing is undoable. Whether I am debugging complex logic or designing a fresh component layout, I know that all a
             challenge requires is a little targeted research and sharp critical thinking, and thankfully, that happens to be my forte. When it comes to delivering results, 
             <span className="font-semibold text-black dark:text-white transition-colors duration-300"> you can always bet on me</span>.
          </p>
        </div>


        {/* Download Resume Button */}
        <div className="text-center" data-aos="fade-up">
          <button 
            onClick={() => {
              const link = document.createElement('a');
              link.href = '/files/DOTUN-CV.pdf';
              link.download = 'DOTUN-CV.pdf';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }}
            className="inline-flex items-center px-8 py-4 bg-black dark:bg-white text-white dark:text-black text-sm font-semibold hover:bg-slate-800 dark:hover:bg-gray-200 transition-colors duration-300"
          >
            Download Resume
          </button>
        </div>
      </div>
    </section>
  );
};

export default About;